@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.github.jangalinski.com.github.jangalinski.tabweb.site.pages.MarkdownPagesPage as _com_github_jangalinski_com_github_jangalinski_tabweb_site_pages_MarkdownPagesPage
import com.github.jangalinski.tabweb.Tabweb.Layout as _com_github_jangalinski_tabweb_Tabweb_Layout
import com.github.jangalinski.tabweb._app.TabwebLayout as _com_github_jangalinski_tabweb__app_TabwebLayout
import com.github.jangalinski.tabweb.site.MarkdownTabwebLayout as _com_github_jangalinski_tabweb_site_MarkdownTabwebLayout
import com.github.jangalinski.tabweb.site.pages.AvatarsPage as _com_github_jangalinski_tabweb_site_pages_AvatarsPage
import com.github.jangalinski.tabweb.site.pages.BadgesPage as _com_github_jangalinski_tabweb_site_pages_BadgesPage
import com.github.jangalinski.tabweb.site.pages.BarChartPage as _com_github_jangalinski_tabweb_site_pages_BarChartPage
import com.github.jangalinski.tabweb.site.pages.ButtonsPage as _com_github_jangalinski_tabweb_site_pages_ButtonsPage
import com.github.jangalinski.tabweb.site.pages.ChartPage as _com_github_jangalinski_tabweb_site_pages_ChartPage
import com.github.jangalinski.tabweb.site.pages.Colors as _com_github_jangalinski_tabweb_site_pages_Colors
import com.github.jangalinski.tabweb.site.pages.Components as _com_github_jangalinski_tabweb_site_pages_Components
import com.github.jangalinski.tabweb.site.pages.Elements as _com_github_jangalinski_tabweb_site_pages_Elements
import com.github.jangalinski.tabweb.site.pages.EmptyPage as _com_github_jangalinski_tabweb_site_pages_EmptyPage
import com.github.jangalinski.tabweb.site.pages.ExtremeCardsPage as _com_github_jangalinski_tabweb_site_pages_ExtremeCardsPage
import com.github.jangalinski.tabweb.site.pages.Index as _com_github_jangalinski_tabweb_site_pages_Index
import com.github.jangalinski.tabweb.site.pages.SampleCardsPage as _com_github_jangalinski_tabweb_site_pages_SampleCardsPage
import com.github.jangalinski.tabweb.site.pages.TablesPage as _com_github_jangalinski_tabweb_site_pages_TablesPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "tabweb"))
    BasePath.set("/tabweb/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx, pageMethod -> 
            _com_github_jangalinski_tabweb_Tabweb_Layout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.github.jangalinski.tabweb._app.TabwebLayout",
        ) { pageCtx, pageMethod -> 
            _com_github_jangalinski_tabweb__app_TabwebLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.github.jangalinski.tabweb.site.MarkdownTabwebLayout",
        ) { pageCtx, pageMethod -> 
            _com_github_jangalinski_tabweb_site_MarkdownTabwebLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_Index()
        }
        ctx.router.register(
            "/components",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_Components()
        }
        ctx.router.register(
            "/elements",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_Elements()
        }
        ctx.router.register(
            "/empty",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_EmptyPage()
        }
        ctx.router.register(
            "/interfaces/avatars",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_AvatarsPage()
        }
        ctx.router.register(
            "/interfaces/badges",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_BadgesPage()
        }
        ctx.router.register(
            "/interfaces/buttons",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_ButtonsPage()
        }
        ctx.router.register(
            "/interfaces/cards",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_SampleCardsPage()
        }
        ctx.router.register(
            "/interfaces/charts",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_ChartPage()
        }
        ctx.router.register(
            "/interfaces/charts/bar",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_BarChartPage()
        }
        ctx.router.register(
            "/interfaces/colors",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_Colors()
        }
        ctx.router.register(
            "/interfaces/extreme-cards",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_ExtremeCardsPage()
        }
        ctx.router.register(
            "/interfaces/tables",
            layoutId = "com.github.jangalinski.tabweb.Tabweb.Layout",
        ) { pageCtx -> 
            _com_github_jangalinski_tabweb_site_pages_TablesPage()
        }
        ctx.router.register(
            "/markdown-pages",
            layoutId = "com.github.jangalinski.tabweb.site.MarkdownTabwebLayout",
            initRouteMethod = { ctx ->
                com.github.jangalinski.com.github.jangalinski.tabweb.site.pages.initMarkdownPagesPage(ctx)
            },
        ) { pageCtx -> 
            _com_github_jangalinski_com_github_jangalinski_tabweb_site_pages_MarkdownPagesPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.github.jangalinski.tabweb.site.AppEntry {
            router.renderActivePage()
        }
    }
}
